import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import * as Feather from 'feather-icons';
import Swal from 'sweetalert2'
declare var iziToast:any;
@Component({
  selector: 'app-contactgroup',
  templateUrl: './contactgroup.component.html',
  styleUrls: ['./contactgroup.component.css']
})
export class ContactgroupComponent implements OnInit {
  recordNotFound = false;
  pageLimit = 10;
  paginationData:any ={"info":"hide"};
  offset_count = 0;
 
  costdata:any=[];
  
   constructor(private router:Router,private serverService: ServerService) { }
 
   ngOnInit(): void {
 
     this.viewall({})
   }
 
     addnewuser(){
 this.router.navigate(['contact-group-edit'], { state: {page:"add"} });
 
     
 
   }
 
 goedit(l){
    localStorage.setItem('cos',l.cost_sender_id); 
 
 this.router.navigate(['costcenteredit'], { state: {page:"edit"} });
 
 
 }
 
 
 viewall(data){
     Swal.fire('Loading')
 Swal.showLoading()
 var list_data= this.listDataInfo(data);
 
   let datas:any =new Object();
  let datasend:any = new Object();
     let access_token: any=localStorage.getItem('at');
     let customer_id: any=localStorage.getItem('en');
    
    
 datas.action="view_all";
 datas.customer_id = customer_id;
 datas.limit = list_data.limit;
 datas.offset = list_data.offset;
 
 
  datasend.access_token=access_token;
   datasend.operation="curlDatas";
   datasend.moduleType="costsender";
   datasend.api_type="web";
   datasend.element_data = datas;
       this.serverService.sendServer(datasend).subscribe((response: any) => {
 console.log(response)
         if(response.status=="true"){
           Swal.close()
      this.costdata = response.options
    
           }
         else{
           Swal.close()
           
 this.costdata =[];
  
         }
    this.offset_count = list_data.offset;
         this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
          console.log(this.paginationData);
                 this.recordNotFound = this.costdata.length == 0 ? true : false;
 
 
       
       }, 
       (error)=>{
           console.log(error);
       });
 
 }
 
 listDataInfo(list_data){
 console.log(list_data)
   list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
   // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
   // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
   list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
   list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
   return list_data;
 } 
 
 getsearch(searchValue: string): void {  
   console.log(searchValue);
   this.viewall({'search_text':searchValue})
 }
 
 
 
 
 godelete(senderid){
 
   let datas:any =new Object();
  let datasend:any = new Object();
     let access_token: any=localStorage.getItem('at');
     let customer_id: any=localStorage.getItem('en');
    
    
 datas.action="delete_cost_sender";
 datas.customer_id = customer_id;
 datas.cost_sender_id = senderid.cost_sender_id;
 
 
 
  datasend.access_token=access_token;
   datasend.operation="curlDatas";
   datasend.moduleType="costsender";
   datasend.api_type="web";
   datasend.element_data = datas;
       this.serverService.sendServer(datasend).subscribe((response: any) => {
 console.log(response)
         if(response.status=="true"){
          iziToast.success({
           message: "Deleted Successfully",
           position: 'topRight'
       });
     this.viewall({})
 
           }
         else{
     iziToast.error({
           message: "Please try again later",
           position: 'topRight'
       });
  
         }
  
 
 
       
       }, 
       (error)=>{
           console.log(error);
       });
 
 }
 
 
 
 
 
 
 
 
 }
 